<!--
 * @Description: Description
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-08-28 13:44:45
 * @LastEditors: FJW
 * @LastEditTime: 2025-02-13 14:59:26
-->
<template>
  <el-container class="home-page">
    <el-aside width="80px" class="navi-bar">
      <div class="user-head-image">
        <head-image :name="$store.state.userStore.userInfo?.nickName" :url="$store.state.userStore.userInfo?.headImageThumb" :size="50" @click.native="showSettingDialog = true">
        </head-image>
        <el-dropdown style="width: 100%" trigger="click" @command="getUpdateUserStatus">
          <span style="cursor: pointer">
            <span v-html="isUserStatus"></span>
            <i class="el-icon-arrow-down el-icon--right" style="color:#fff"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="0">在线</el-dropdown-item>
            <el-dropdown-item :command="1">挂起</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-menu background-color="#19082f" style="margin-top: 25px;">
        <el-menu-item title="聊天">
          <router-link class="link" v-bind:to="'/home/chat'">
            <span class="icon iconfont icon-chat"></span>
            <div v-show="unreadCount > 0" class="unread-text">{{ unreadCount }}</div>
          </router-link>
        </el-menu-item>
        <el-menu-item title="好友">
          <router-link class="link" v-bind:to="'/home/friend'">
            <span class="icon iconfont icon-friend"></span>
          </router-link>
        </el-menu-item>
        <!-- <el-menu-item title="群聊">
          <router-link class="link" v-bind:to="'/home/group'">
            <span class="icon iconfont icon-group"></span>
          </router-link>
        </el-menu-item> -->
        <el-menu-item title="设置" @click="showSetting()">
          <span class="icon iconfont icon-setting"></span>
        </el-menu-item>
        <el-menu-item title="修改密码" @click="showPassword()">
          <span class="icon iconfont icon-password"></span>
        </el-menu-item>
      </el-menu>
      <div class="exit-box" @click="onExit()" title="退出">
        <span class="icon iconfont icon-exit"></span>
      </div>
    </el-aside>
    <el-main class="content-box">
      <router-view></router-view>
    </el-main>
    <setting :visible="showSettingDialog" @close="closeSetting()"></setting>
    <password :visible="showPasswordDialog" @close="closePassword()"></password>
    <user-info v-show="uiStore.userInfo.show" :pos="uiStore.userInfo.pos" :user="uiStore.userInfo.user" @close="$store.commit('closeUserInfoBox')"></user-info>
    <full-image :visible="uiStore.fullImage.show" :url="uiStore.fullImage.url" @close="$store.commit('closeFullImageBox')"></full-image>
    <chat-private-video ref="privateVideo"></chat-private-video>
    <chat-video-acceptor ref="videoAcceptor"></chat-video-acceptor>
  </el-container>
</template>

<script>
import HeadImage from '../components/common/HeadImage.vue';
import Setting from '../components/setting/Setting.vue';
import Password from '../components/password/Password.vue';
import UserInfo from '../components/common/UserInfo.vue';
import FullImage from '../components/common/FullImage.vue';
import ChatPrivateVideo from '../components/chat/ChatPrivateVideo.vue';
import ChatVideoAcceptor from '../components/chat/ChatVideoAcceptor.vue';

export default {
  components: {
    HeadImage,
    Setting,
    Password,
    UserInfo,
    FullImage,
    ChatPrivateVideo,
    ChatVideoAcceptor
  },
  data() {
    return {
      showSettingDialog: false,
      showPasswordDialog: false,
      lastPlayAudioTime: new Date().getTime() - 1000,
      isHiddenStatus: false,
      msgContent: ''
    }
  },
  methods: {
    getUpdateUserStatus(status) {
      this.$http.post(`/updateHangupStatus`, null, {
        params: {
          status: status
        }
      }).then(() => {
        this.$store.dispatch("loadUser")
      })
    },

    init() {
      this.$store.dispatch("load").then(() => {
        // ws初始化
        this.$wsApi.connect(process.env.VUE_APP_WS_URL, sessionStorage.getItem("accessToken"))
        this.$wsApi.onConnect(() => {
          // 加载离线消息
          this.pullPrivateOfflineMessage(this.$store.state.chatStore.privateMsgMaxId)
          this.pullGroupOfflineMessage(this.$store.state.chatStore.groupMsgMaxId)
        })
        this.$wsApi.onMessage((cmd, msgInfo) => { //
          if (cmd == 2) {
            // 关闭ws
            setTimeout(() => {
              if (this.isHiddenStatus) {
                let button = document.createElement('button');
                button.innerHTML = '关闭';
                button.style.display = 'none'
                document.body.appendChild(button)
                button.addEventListener('click', () => {
                  window.close()
                })
                button.click()
              }
            }, 2000)
            this.$wsApi.close(3000)
            // 异地登录，强制下线
            this.$alert("您已在其他地方登录，将被强制下线", "强制下线通知", {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.push("/");
                sessionStorage.removeItem("accessToken")
                sessionStorage.removeItem("accessId")
              }
            })

          } else if (cmd == 3) {
            // 插入私聊消息
            this.handlePrivateMessage(msgInfo); //每条消息数据
          } else if (cmd == 4) {
            // 插入群聊消息
            this.handleGroupMessage(msgInfo);
          }
        })
        this.$wsApi.onClose((e) => {
          if (e.code != 3000) {
            // 断线重连
            this.$message.error("连接断开，正在尝试重新连接...");
            this.$wsApi.reconnect(process.env.VUE_APP_WS_URL, sessionStorage.getItem("accessToken"));
          }
        })
      }).catch((e) => {
      })
    },
    pullPrivateOfflineMessage(minId) {
      this.$http({
        url: "/message/private/pullOfflineMessage?minId=" + minId,
        method: 'get'
      });
    },
    pullGroupOfflineMessage(minId) {
      this.$http({
        url: "/message/group/pullOfflineMessage?minId=" + minId,
        method: 'get'
      });
    },
    handlePrivateMessage(msg) { //msg每条消息数据
      this.msgContent = msg.content
      // 消息加载标志
      if (msg.type == this.$enums.MESSAGE_TYPE.LOADDING) {
        this.$store.commit("loadingPrivateMsg", JSON.parse(msg.content))
        return;
      }
      // 消息已读处理，清空已读数量
      if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
        this.$store.commit("resetUnreadCount", {
          type: 'PRIVATE',
          targetId: msg.recvId
        })
        return;
      }
      // 消息回执处理,改消息状态为已读
      if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
        this.$store.commit("readedMessage", {
          friendId: msg.sendId
        })
        return;
      }
      // 标记这条消息是不是自己发的
      msg.selfSend = msg.sendId == this.$store.state.userStore.userInfo.id;
      // 好友id
      let friendId = msg.selfSend ? msg.recvId : msg.sendId;
      this.loadFriendInfo(friendId).then((friend) => {
        if (friend) {
          if (msg.isKeFu) {
            msg.headImage = friend.headImage
            msg.nickName = friend.nickName
          }
          this.insertPrivateMessage(friend, msg);
        }
      })
    },
    insertPrivateMessage(friend, msg) {
      // webrtc 信令
      if (msg.type >= this.$enums.MESSAGE_TYPE.RTC_CALL_VOICE &&
        msg.type <= this.$enums.MESSAGE_TYPE.RTC_CANDIDATE) {
        let rtcInfo = this.$store.state.userStore.rtcInfo;
        // 呼叫
        if (msg.type == this.$enums.MESSAGE_TYPE.RTC_CALL_VOICE ||
          msg.type == this.$enums.MESSAGE_TYPE.RTC_CALL_VIDEO ||
          rtcInfo.state == this.$enums.RTC_STATE.FREE ||
          rtcInfo.state == this.$enums.RTC_STATE.WAIT_ACCEPT) {
          this.$refs.videoAcceptor.onRTCMessage(msg, friend)
        } else {
          this.$refs.privateVideo.onRTCMessage(msg)
        }
        return;
      }
      let chatInfo = {
        type: 'PRIVATE',
        targetId: friend.id,
        showName: friend.nickName,
        headImage: friend.headImage,
        currentUserId: friend.id,
        userType: friend.type,
        sessionId: friend.sessionId,
        kmallUserId: friend.kmallUserId
      }
      // 打开会话
      this.$store.commit("openChat", chatInfo);
      // 插入消息
      this.$store.commit("insertMessage", msg);
      // 播放提示音
      if (!msg.selfSend && msg.status != this.$enums.MESSAGE_STATUS.READED) {
        this.playAudioTip();
      }
    },
    handleGroupMessage(msg) {
      // 消息加载标志
      if (msg.type == this.$enums.MESSAGE_TYPE.LOADDING) {
        this.$store.commit("loadingGroupMsg", JSON.parse(msg.content))
        return;
      }
      // 消息已读处理
      if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
        // 我已读对方的消息，清空已读数量
        let chatInfo = {
          type: 'GROUP',
          targetId: msg.groupId
        }
        this.$store.commit("resetUnreadCount", chatInfo)
        return;
      }
      // 消息回执处理
      if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
        // 更新消息已读人数
        let msgInfo = {
          id: msg.id,
          groupId: msg.groupId,
          readedCount: msg.readedCount,
          receiptOk: msg.receiptOk
        };
        this.$store.commit("updateMessage", msgInfo)
        return;
      }
      // 标记这条消息是不是自己发的
      msg.selfSend = msg.sendId == this.$store.state.userStore.userInfo.id;
      this.loadGroupInfo(msg.groupId).then((group) => {
        // 插入群聊消息
        this.insertGroupMessage(group, msg);
      })
    },
    insertGroupMessage(group, msg) {
      let chatInfo = {
        type: 'GROUP',
        targetId: group.id,
        showName: group.remark,
        headImage: group.headImageThumb
      };
      // 打开会话
      this.$store.commit("openChat", chatInfo);
      // 插入消息
      this.$store.commit("insertMessage", msg);
      // 播放提示音
      if (!msg.selfSend && msg.status != this.$enums.MESSAGE_STATUS.READED) {
        this.playAudioTip();
      }
    },
    onExit() {
      this.$confirm(`即将退出, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$wsApi.close(3000);
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("accessId");
        this.$router.push("/");
      })
    },
    playAudioTip() {
      if (new Date().getTime() - this.lastPlayAudioTime > 1000) {
        this.lastPlayAudioTime = new Date().getTime();
        let audio = new Audio();
        let url = require(`@/assets/audio/tip.wav`);
        audio.src = url;
        audio.muted = true;
        audio.play();
      }

    },
    showSetting() {
      this.showSettingDialog = true;
    },
    showPassword() {
      this.showPasswordDialog = true
    },
    closeSetting() {
      this.showSettingDialog = false;
    },
    closePassword() {
      this.showPasswordDialog = false;
    },
    loadFriendInfo(id) {
      return new Promise((resolve, reject) => {
        let friend = this.$store.state.friendStore.friends.find((f) => f.id == id);
        if (friend) {
          resolve(friend);
        } else {
          this.$http({
            url: `/friend/find/${id}`,
            method: 'get'
          }).then((friend) => {
            this.$store.commit("addFriend", friend);
            resolve(friend)
          })
        }
      });
    },
    loadGroupInfo(id) {
      return new Promise((resolve, reject) => {
        let group = this.$store.state.groupStore.groups.find((g) => g.id == id);
        if (group) {
          resolve(group);
        } else {
          this.$http({
            url: `/group/find/${id}`,
            method: 'get'
          }).then((group) => {
            resolve(group)
            this.$store.commit("addGroup", group);
          })
        }
      });
    },

    // 发送消息
    showNotification(message) {
      const that = this
      const sendNotification = (message) => {
        let notification = new Notification('您有一条新的消息, 请查看', {
          body: message,
          renotify: true,
          tag: 'kefu',
          icon: '/img/logo.png'
        })
        notification.onclick = function () {
          that.isHiddenStatus = false
          window.focus();
          notification.close();
        }
      }
      if (Notification.permission === 'granted') {
        // 如果已经获得权限，可以直接发送通知
        sendNotification(message)
      } else if (Notification.permission !== 'denied') {
        // 如果用户还未做出选择，则请求权限
        Notification.requestPermission().then(function (permission) {
          // 回调函数会在用户做出选择后被调用
          if (permission === 'granted') {
            // 用户允许显示通知
            sendNotification(message)
          }
        })
      }
    },

    getKeyBroadEvent() {
      if (window?.event?.keyCode === 117) {
        const userId = this.$store.state.userStore.userInfo.id
        const key = "chats-" + userId
        localStorage.removeItem(key)
        window.location.reload()
      }
    }
  },
  computed: {
    isUserStatus() {
      const mapTable = {
        0: {
          name: '在线',
          fontColor: '#32CD32'
        },
        1: {
          name: '挂起',
          fontColor: '#c7515a'
        },
        'default': {
          name: '未知',
          fontColor: '#fff'
        },
      }
      let status = mapTable[this.$store.state.userStore.userInfo?.hangupStatus] || mapTable['default']
      return `<span style="color: ${status.fontColor}">${status.name}</span>`
    },
    uiStore() {
      return this.$store.state.uiStore;
    },
    unreadCount() {
      let unreadCount = 0;
      let chats = this.$store.state.chatStore.chats;
      chats.forEach((chat) => {
        unreadCount += chat.unreadCount
      });
      return unreadCount;
    }
  },
  watch: {
    unreadCount: {
      handler(newCount, oldCount) {
        let tip = newCount > 0 ? `${newCount}条未读` : "";
        this.$elm.setTitleTip(tip);
        if (this.isHiddenStatus && newCount > 0) {
          this.showNotification(this.msgContent)
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.init();
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.isHiddenStatus = true
      } else {
        this.isHiddenStatus = false
      }
    })
    document.addEventListener('keydown', this.getKeyBroadEvent)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.getKeyBroadEvent)
  },
  unmounted() {
    this.$wsApi.close();
  }
}
</script>

<style scoped lang="scss">
.navi-bar {
  background: #19082f;
  padding: 15px;
  padding-top: 50px;

  .el-menu {
    border: none;
    flex: 1;

    .el-menu-item {
      margin: 20px 0;
      background-color: #19082f !important;
      padding: 0 !important;
      text-align: center;
      .link {
        text-decoration: none;

        &.router-link-active .icon {
          color: #ba785a;
        }
      }

      .icon {
        font-size: 26px !important;
        color: #ddd;
      }

      .unread-text {
        position: absolute;
        line-height: 20px;
        background-color: #f56c6c;
        left: 36px;
        top: 7px;
        color: white;
        border-radius: 30px;
        padding: 0 5px;
        font-size: 10px;
        text-align: center;
        white-space: nowrap;
        border: 1px solid #f1e5e5;
      }
    }
  }

  .exit-box {
    position: absolute;
    width: 60px;
    bottom: 40px;
    color: #ccc;
    text-align: center;
    cursor: pointer;

    .icon {
      font-size: 28px;
    }

    &:hover {
      color: white;
    }
  }
}

.content-box {
  padding: 0;
  background-color: #f0f2f5;
  color: black;
  text-align: center;
}
</style>